import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "SharedComponents/ScrollToTop";
import Login from "Pages/Login";
import { useSelector } from "react-redux";
import PageForbidden from "SharedComponents/403";
import PageNotFound from "SharedComponents/404";
import HomeLayout from "Layouts/HomeLayout";
import HotelLayout from "Layouts/HotelLayout";
import Dashboardpage from "Pages/Dashboard";
import ProfileSettings from "Pages/Profile/ProfileSettings";
import AvailableBanks from "Pages/Availablebanks"
import Accounttypes from "Pages/Accounttypes"

import DashboardHotel from "Pages/DashboardHotel";
import MytripsHotel from "Pages/MytripsHotel";
import UpcomingtripsHotel from "Pages/UpcomingtripsHotel";

import Dashboardcorporate from "Pages/DashboardCorporate";
import Corporategroup from "Pages/Corporategroup";
import CorporateEmployee from "Pages/CorporateEmployee";
import OverallreportCorp from "Pages/OverallreportCorp"
import DailyreportCorp from "Pages/DailyreportCorp"
import MontlyreportCorp from "Pages/MontlyreportCorp"
import YearlyreportCorp from "Pages/YearlyreportCorp"

// Settings Route
import Settings from "Pages/Profile/Settings";
import SiteSettings from "Pages/Settings/SiteSettings";
import PaymentSettings from "Pages/Settings/PaymentSettings";
import PlatformfeeSettings from "Pages/Settings/PlatformfeeSettings";
import UserrewardSettings from "Pages/Settings/UserrewardSettings";
import BusinessSettings from "Pages/Settings/BusinessSettings";
import ChangePassword from "Pages/Settings/ChanagePassword";
import HotelChangePassword from "Pages/Settings/HotelChangePassword";
import LegalSettings from "Pages/Settings/LegalSettings";
import Termsandcondition from "Pages/Settings/Termsandcondition"
import PrivacyPolicy from "Pages/Settings/PrivacyPolicy"

// Icons
import { Dashboard , PersonAddAlt1 ,Photo, LocalTaxi, Discount , AssignmentInd,  
  SettingsSuggest, ManageSearch , EmojiTransportation , 
  History , SupportAgent , Assessment , Wallet , Message , RateReview , MoneyOffCsredOutlined , AttachMoney , BalanceTwoTone } from "@mui/icons-material";


import AddLocation from "Pages/ZoneManagement/AddLocation";
import ListLocation from "Pages/ZoneManagement/ListLocation";
import RestrictLocation from "Pages/ZoneManagement/RestrictLocation";
// import Demoaccount from "Pages/Demoaccount";
import Passenger from "Pages/Passenger";
import TestPage from "Pages/TestPage";
import Driver from "Pages/Driver";
import Dispatcher from "Pages/Dispatcher";
import Accountmanager from "Pages/Accountmanager";
import Subcompany from "Pages/Subcompany";
import Corporate from "Pages/Corporate";
import Hotel from "Pages/Hotel";
import HotelWallet from "Pages/HotelWallet";
import Userwallet from "Pages/Userwallet";
import Userwalletlogs from "Pages/Userwalletlogs";
import Driverwallet from "Pages/Driverwallet";
import Driverrewards from "Pages/Driverreward";
import Driverearnings from "Pages/Driverearnings";
import Driverearningslogs from "Pages/Driverearningslogs";
import Driverrewardlogs from "Pages/Driverrewardlogs";
import Promocodes from "Pages/Promocodes"
import Cashoutrecords from "Pages/Cashoutrecords";
import Cashoutrejected from "Pages/Cashoutrejected";
import Cashoutapproved from "Pages/Cashoutapproved";
import Cashoutsheets from "Pages/Cashoutsheets";
import Driverwalletlogs from "Pages/Driverwalletlogs";
import Servicetype from "Pages/ServiceType";
import BannerTemplateManage from "Pages/BannerTemplateManage";
import Servicetypefare from "Pages/Servicetypefare"
import ServicetypeZonefare from "Pages/ServicetypeZonefare"
import PassengerHistory from "Pages/Passengerhistory"
import Overallreport from "Pages/Overallreport"
import Dailyreport from "Pages/Dailyreport"
import Monthlyreport from "Pages/Monthlyreport"           
import Yearlyreport from "Pages/Yearlyreport"
import Kmdrivendurationreport from 'Pages/kmdrivendurationreport'
import Driversreport from "Pages/Driversreport"
import Driverreport from "Pages/Driversreport/Driverreport"
import KMdriverreport from "Pages/kmdrivendurationreport/Driverreport"
import Triplist from "Pages/Triplisttwo"
import HotelTriplisttwo from "Pages/HotelTriplisttwo"
import Dispatcherpanel from "Pages/Dispatcherpanel"
import Smsnotifications from "Pages/Smsnotifications"
import Mailnotifications from "Pages/Mailnotifications"
import Pushnotifications from "Pages/Pushnotifications"
import Userratings from "Pages/Userratings";
import Driverratings from "Pages/Driverratings";

const Router = () => {
  const isAuthenticated = useSelector(
    (state) => state?.AuthReducer?.isAuthenticated || false
  );
  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );
  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );
  const PrivateRoute = ({ children, icon, label, noPadding }) => {
    if (isAuthenticated) {
      return (
        <>
          <HomeLayout
            children={children}
            icon={icon}
            label={label}
            noPadding={noPadding}
          />
        </>
      );
    } else return <Navigate to="/" />;
  };

const HotelPrivateRoute = ({ children, icon, label, noPadding }) => {
  if (isAuthenticated) {

    return (
     <HotelLayout icon={icon} label={label} noPadding={noPadding}>
        {children}
      </HotelLayout>
    );
  } else return <Navigate to="/" />;
};

  const HomeRoute = () => {
    if (isAuthenticated) {
      if(userType == "CORPORATE"){
         return <Navigate replace to="/dashboard_corporate" />;
      }
      if(userType == "HOTEL"){
        return <Navigate replace to="/dashboard_hotel" />
      }
      return <Navigate replace to="/dashboard" />;
    } else return <Login />;
  };

  return (
    <BrowserRouter>
      <ScrollToTop>
        <Routes>
<Route path="/" element={<HomeRoute />} />
<Route path="/dashboard" element={<PrivateRoute icon={<Dashboard />} label={"Dashboard"}><Dashboardpage /></PrivateRoute>} />
<Route path="/add-location" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Add Location"}><AddLocation /></PrivateRoute>} />
<Route path="/list-location" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"List Location"}><ListLocation /></PrivateRoute>} />
<Route path="/restrict-location" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Restrict Location"}><RestrictLocation /></PrivateRoute>} />
<Route path="/passenger" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Passenger"}><Passenger /></PrivateRoute>} />
 {/* {!demoaccount_id && <Route path="/demoaccount" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Demo Account"}><Demoaccount /></PrivateRoute>} />} */}
<Route path="/driver" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Driver"}><Driver /></PrivateRoute>} />
<Route path="/dispatcher" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Dispatcher"}><Dispatcher /></PrivateRoute>} />
<Route path="/account-manager" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Account manager"}><Accountmanager /></PrivateRoute>} />
<Route path="/sub-company" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Sub company"}><Subcompany /></PrivateRoute>} />
<Route path="/hotel" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Hotel/restaurant"}><Hotel /></PrivateRoute>} />
<Route path="/corporate" element={<PrivateRoute icon={<PersonAddAlt1 />} label={"Corporate"}><Corporate /></PrivateRoute>} />
<Route path="/servicetype" element={<PrivateRoute icon={<LocalTaxi />} label={"Service type"}><Servicetype /></PrivateRoute>} />
<Route path="/BannerTemplateManage" element={<PrivateRoute icon={<Photo />} label={"Banner Template Management"}><BannerTemplateManage /></PrivateRoute>} />
<Route path="/servicetypefare" element={<PrivateRoute icon={<EmojiTransportation />} label={"Service Type Fare"}><Servicetypefare /></PrivateRoute>} />
<Route path="/ServicetypeZonefare" element={<PrivateRoute icon={<EmojiTransportation />} label={"Zone-based fare"}><ServicetypeZonefare /></PrivateRoute>} />
<Route path="/passengerhistory" element={<PrivateRoute icon={<History />} label={"Request History"}><PassengerHistory /></PrivateRoute>} />
<Route path="/triplist" element={<PrivateRoute icon={<History />} label={"Trip List"}><Triplist /></PrivateRoute>} />
<Route path="/dispatcherpanel" element={<Dispatcherpanel />} />
{/* <Route path="/triplist" element={<Triplist />} /> */}
<Route path="/overallreport" element={<PrivateRoute icon={<Assessment />} label={"Overall Report"}><Overallreport /></PrivateRoute>} />
<Route path="/dailyreport" element={<PrivateRoute icon={<Assessment />} label={"Daily Report"}><Dailyreport /></PrivateRoute>} />
<Route path="/monthlyreport" element={<PrivateRoute icon={<Assessment />} label={"Monthly Report"}><Monthlyreport /></PrivateRoute>} />
<Route path="/yearlyreport" element={<PrivateRoute icon={<Assessment />} label={"Yearly Report"}><Yearlyreport /></PrivateRoute>} />

<Route path="/driversreport" element={<PrivateRoute icon={<Assessment />} label={"Drivers Statement"}><Driversreport /></PrivateRoute>} />
<Route path="/driverreport" element={<PrivateRoute icon={<Assessment />} label={"Driver Statement"}><Driverreport /></PrivateRoute>} />
<Route path="/kmdriven-duration-report" element={<PrivateRoute icon={<Assessment />} label={"Km Driven / Duration Report"}><Kmdrivendurationreport /></PrivateRoute>} />
<Route path="/kmdriverreport" element={<PrivateRoute icon={<Assessment />} label={"Km Driven / Duration Statement"}><KMdriverreport /></PrivateRoute>} />
<Route path="/user-wallet" element={<PrivateRoute icon={<Wallet />} label={"Users’ Wallet"}><Userwallet /></PrivateRoute>} />
<Route path="/user-wallet-logs/:id/:user_id" element={<PrivateRoute> <Userwalletlogs /></PrivateRoute>} />
<Route path="/user-reward-settings" element={<PrivateRoute icon={<AssignmentInd />} label={"User reward Settings"}><UserrewardSettings /></PrivateRoute>} />
<Route path="/driver-wallet" element={<PrivateRoute icon={<Wallet />} label={"Driver Wallet"}><Driverwallet /></PrivateRoute>} />
<Route path="/driver-wallet-logs/:id/:user_id" element={<PrivateRoute> <Driverwalletlogs /></PrivateRoute>} />
<Route path="/smsnotifications" element={<PrivateRoute ><Smsnotifications /></PrivateRoute>} />
<Route path="/mailnotifications" element={<PrivateRoute ><Mailnotifications /></PrivateRoute>} />
<Route path="/pushnotifications" element={<PrivateRoute ><Pushnotifications /></PrivateRoute>} />
<Route path="/userratings" element={<PrivateRoute icon={<RateReview />} label={"User rating"}><Userratings /></PrivateRoute>} />
<Route path="/driverratings" element={<PrivateRoute icon={<RateReview />} label={"Driver rating"}><Driverratings /></PrivateRoute>} />
<Route path="/driver-rewards" element={<PrivateRoute icon={<MoneyOffCsredOutlined />} label={"Driver Rewards"}><Driverrewards /></PrivateRoute>} />
<Route path="/driver-reward-logs/:id" element={<PrivateRoute> <Driverrewardlogs /></PrivateRoute>} />
<Route path="/driver-earnings" element={<PrivateRoute icon={<MoneyOffCsredOutlined />} label={"Driver Earnings"}><Driverearnings /></PrivateRoute>} />
<Route path="/driver-earning-logs/:id" element={<PrivateRoute> <Driverearningslogs /></PrivateRoute>} />
<Route path="/cashoutrecords" element={<PrivateRoute icon={<AttachMoney />} label={"Cashout records"}><Cashoutrecords /></PrivateRoute>} />
<Route path="/cashoutsapproved" element={<PrivateRoute icon={<AttachMoney />} label={"Cashouts approved"}><Cashoutapproved /></PrivateRoute>} />
<Route path="/cashoutsrejected" element={<PrivateRoute icon={<AttachMoney />} label={"Cashout rejected"}><Cashoutrejected /></PrivateRoute>} />
<Route path="/cashoutsheets" element={<PrivateRoute icon={<AttachMoney />} label={"Cashout sheets"}><Cashoutsheets /></PrivateRoute>} />
<Route path="/admin-commission-settings" element={<PrivateRoute icon={<AssignmentInd />} label={"Admin Commission Settings"}><PlatformfeeSettings /></PrivateRoute>} />

<Route path="/account-type-settings" element={<PrivateRoute icon={<BalanceTwoTone />} label={"Account_types_settings"}><Accounttypes /></PrivateRoute>} />
<Route path="/profilesettings" element={<PrivateRoute icon={<AssignmentInd />} label={"Profile Settings"}><ProfileSettings /></PrivateRoute>} />
<Route path="/promocodes" element={<PrivateRoute icon={<Discount />} label={"Promo codes"}><Promocodes /></PrivateRoute>} />
<Route path="/available_banks" element={<PrivateRoute icon={<BalanceTwoTone />} label={"Available Banks"}><AvailableBanks /></PrivateRoute>} />
<Route path="/site-settings" element={<PrivateRoute icon={<AssignmentInd />} label={"Site Settings"}><SiteSettings /></PrivateRoute>} />
<Route path="/payment-settings" element={<PrivateRoute icon={<AssignmentInd />} label={"Payment Settings"}><PaymentSettings /></PrivateRoute>} />
<Route path="/business-settings" element={<PrivateRoute icon={<AssignmentInd />} label={"Business Settings"}><BusinessSettings /></PrivateRoute>} />
<Route path="/change-password" element={<PrivateRoute icon={<AssignmentInd />} label={"Change Password"}><ChangePassword /></PrivateRoute>} />
<Route path="/legal-settings" element={<PrivateRoute icon={<AssignmentInd />} label={"Legal Settings"}><LegalSettings /></PrivateRoute>} />
<Route path="/terms-conditions" element={<PrivateRoute icon={<AssignmentInd />} label={"Terms & Condition"}><Termsandcondition /></PrivateRoute>} />
<Route path="/privacy-policy" element={<PrivateRoute icon={<AssignmentInd />} label={"Privacy Policy"}><PrivacyPolicy /></PrivateRoute>} />
<Route path="/settings" element={<PrivateRoute icon={<SettingsSuggest />} label={"Settings"}><Settings /></PrivateRoute>} />
<Route path="/test-page" element={<PrivateRoute label={"Test page"}><TestPage /></PrivateRoute>} />

<Route path="/dashboard_hotel" element={<HotelPrivateRoute icon={<Dashboard />} label={"Dashboard"}><DashboardHotel /></HotelPrivateRoute>} />
<Route path="/hotel-wallet" element={<HotelPrivateRoute icon={<Wallet />} label={"Hotel Wallet"}><HotelWallet /></HotelPrivateRoute>} />
<Route path="/profilesettings_hotel" element={<HotelPrivateRoute icon={<AssignmentInd />} label={"Profile Settings"}><ProfileSettings /></HotelPrivateRoute>} />
<Route path="/mytrips_hotel" element={<HotelPrivateRoute icon={<AssignmentInd />} label={"Mytrips Settings"}><MytripsHotel /></HotelPrivateRoute>} />
<Route path="/upcomingtrips_hotel" element={<HotelPrivateRoute icon={<AssignmentInd />} label={"Upcomingtrips Settings"}><UpcomingtripsHotel /></HotelPrivateRoute>} />
<Route path="/hoteltriplist" element={<HotelPrivateRoute icon={<History />} label={"Hotel TripList"}><HotelTriplisttwo /></HotelPrivateRoute>} />
<Route path="/hotelchange-password" element={<HotelPrivateRoute icon={<AssignmentInd />} label={"Change Password"}><HotelChangePassword /></HotelPrivateRoute>} />

<Route path="/dashboard_corporate" element={<PrivateRoute icon={<Dashboard />} label={"Dashboard"}><Dashboardcorporate /></PrivateRoute>} />
<Route path="/corporate_group" element={<PrivateRoute icon={<Dashboard />} label={"Corporate Group"}><Corporategroup /></PrivateRoute>} />
<Route path="/corporate_employee" element={<PrivateRoute icon={<Dashboard />} label={"Corporate Employee"}><CorporateEmployee /></PrivateRoute>} />
<Route path="/overallreport_corp" element={<PrivateRoute icon={<Assessment />} label={"Overall Report"}><OverallreportCorp /></PrivateRoute>} />
<Route path="/dailytripreport_corp" element={<PrivateRoute icon={<Assessment />} label={"Daily Report"}><DailyreportCorp /></PrivateRoute>} />
<Route path="/monthlytripreport_corp" element={<PrivateRoute icon={<Assessment />} label={"Monthly Report"}><MontlyreportCorp /></PrivateRoute>} />
<Route path="/yearlytripreport_corp" element={<PrivateRoute icon={<Assessment />} label={"Yearly Report"}><YearlyreportCorp /></PrivateRoute>} />


<Route path="/403" element={<PageForbidden />} />
<Route path="/*" element={<PageNotFound />} />

        </Routes>
      </ScrollToTop>
    </BrowserRouter>
  );
};

export default Router;
